.cw{display:inline-flex;}